import currencyString from './currency-string';
export default currencyString('$');
